import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarM from './components/Navbar'
import './fonts.css'
import './custom.scss'
import mainLogo from './img/mainLogo.svg'
import HeroSec from './components/HeroSec';
import Need from './components/Need';
import Partner from './components/Partner';
import Service from './components/Service';
import FooterU from './components/FooterU';
import Footer from './components/Footer';
import LatestNewsPage from './pages/LatestNewsPage';
import ArticlePage from './pages/ArticlePage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import AboutUsPage from './pages/AboutUsPage';


function MainPage() {
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="heroMain">
        <div className={`heroSec ${scroll ? 'heroSec__' : ""}`}>
          <NavbarM logo={mainLogo} setNewsPage={() => {}} />
          <HeroSec />
        </div>
        <Service title="Epilog successfully engages people in making life's important transitions" />
        <Need />
      </div>
      <div className="serviceBg">
        <Partner />
      </div>
      <FooterU />
      <Footer />
    </>
  );
}


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/latest_news" element={<LatestNewsPage />} />
        <Route path="/article" element={<ArticlePage />} />
        <Route path="/case_studies" element={<CaseStudiesPage />} />
        <Route path="/about_us" element={<AboutUsPage />} />
      </Routes>
    </BrowserRouter>
  );
}


export default App;
